/* import __COLOCATED_TEMPLATE__ from './verify-identity.hbs'; */
/* RESPONSIBLE TEAM: team-data-foundations */
import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import type Store from '@ember-data/store';
import type Session from 'embercom/services/session';

export interface Args {
  otpAuthEnabled: boolean;
  onUpdateOtpAuthEnabled: () => void;
  workflowAction: any;
  isMessengerInstalledAndProtected: boolean;
}

interface Signature {
  Element: HTMLElement;
  Args: Args;
}

export default class VerifyIdentity extends Component<Signature> {
  @service declare store: Store;
  @service declare appService: AppService;
  @service declare session: Session;
  @service declare attributeService: any;

  @tracked emailAttribute: Record<string, any> | undefined;

  constructor(owner: unknown, args: any) {
    super(owner, args);
    this.emailAttribute = this.attributeService.attributes.find(
      (attribute: any) => attribute.identifier === 'email',
    );
  }

  @action
  handleOTPSwitchToggle() {
    this.args.onUpdateOtpAuthEnabled();
  }

  get isMessengerInstalledAndProtected() {
    return this.args.isMessengerInstalledAndProtected;
  }

  get idvSetupUrl() {
    return 'apps.app.settings.channels.messenger.security';
  }

  get app() {
    return this.appService.app;
  }

  get hasCustomDomains() {
    return (
      this.app?.customEmailAddresses.filter((address: $TSFixMe) => address.verified).length > 0
    );
  }

  get isEmailAttributeNotProtected() {
    return !this.emailAttribute?.preventUpdateFromMessenger;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'WorkflowConnector::Builder::Body::Sections::Request::VerifyIdentity': typeof VerifyIdentity;
    'workflow-connector/builder/body/sections/request/verify-identity': typeof VerifyIdentity;
  }
}
